import { render } from "./team-manage.vue?vue&type=template&id=4b145114&scoped=true&ts=true"
import script from "./team-manage.vue?vue&type=script&lang=ts"
export * from "./team-manage.vue?vue&type=script&lang=ts"

import "./team-manage.vue?vue&type=style&index=0&id=4b145114&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b145114"]])

export default __exports__